import SelectUI from "components/ui/SelectUI/SelectUI";
import { Input } from "components/ui";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import {
    AUTOMATION_CONDITION_FIELD,
    CONDITION_FIELD_OPTIONS,
    OPERATOR_OPTIONS,
    PHASE_OPTIONS,
    SOURCE_OPTIONS,
    TICKET_STATUS_OPTIONS,
} from "../../enum";
import "./AutomationConditionGroup.scss";

const findOption = (options, value) =>
    options.find((option) => option.value === value) || null;

const AutomationConditionGroup = ({
    title,
    group,
    conditions,
    onUpdate,
    onAdd,
    onRemove,
}) => {
    const renderValueInput = (condition, index) => {
        if (condition.field === AUTOMATION_CONDITION_FIELD.TICKET_STATUS) {
            return (
                <SelectUI
                    name={`value-${group}-${index}`}
                    placeholder='Value'
                    options={TICKET_STATUS_OPTIONS}
                    value={findOption(TICKET_STATUS_OPTIONS, condition.value)}
                    onChange={({ value }) =>
                        onUpdate(group, index, "value", value)
                    }
                />
            );
        }

        if (condition.field === AUTOMATION_CONDITION_FIELD.TICKET_PHASE) {
            return (
                <SelectUI
                    name={`value-${group}-${index}`}
                    placeholder='Value'
                    options={PHASE_OPTIONS}
                    value={findOption(PHASE_OPTIONS, condition.value)}
                    onChange={({ value }) =>
                        onUpdate(group, index, "value", value)
                    }
                />
            );
        }

        if (condition.field === AUTOMATION_CONDITION_FIELD.TICKET_SOURCE) {
            return (
                <SelectUI
                    name={`value-${group}-${index}`}
                    placeholder='Value'
                    options={SOURCE_OPTIONS}
                    value={findOption(SOURCE_OPTIONS, condition.value)}
                    onChange={({ value }) =>
                        onUpdate(group, index, "value", value)
                    }
                />
            );
        }

        if (
            condition.field === AUTOMATION_CONDITION_FIELD.HOURS_SINCE_STATUS ||
            condition.field ===
                AUTOMATION_CONDITION_FIELD.HOURS_SINCE_LAST_ACTIVITY
        ) {
            return (
                <Input
                    type='number'
                    grpClass='mb-0'
                    inputClass='form-control'
                    name={`value-${group}-${index}`}
                    placeholder='Hours'
                    value={condition.value}
                    onChange={({ target: { value } }) =>
                        onUpdate(group, index, "value", Number(value))
                    }
                />
            );
        }

        if (condition.field === AUTOMATION_CONDITION_FIELD.NO_AGENT_REPLY) {
            return (
                <SelectUI
                    name={`value-${group}-${index}`}
                    placeholder='Value'
                    options={[
                        { label: "True", value: true },
                        { label: "False", value: false },
                    ]}
                    value={
                        condition.value === true || condition.value === "true"
                            ? { label: "True", value: true }
                            : { label: "False", value: false }
                    }
                    onChange={({ value }) =>
                        onUpdate(group, index, "value", value)
                    }
                />
            );
        }

        return (
            <Input
                grpClass='mb-0'
                inputClass='form-control'
                name={`value-${group}-${index}`}
                placeholder='Value'
                value={String(condition.value ?? "")}
                onChange={({ target: { value } }) =>
                    onUpdate(group, index, "value", value)
                }
            />
        );
    };

    return (
        <section className='automation-condition-group'>
            <h5>{title}</h5>

            {(conditions || []).map((condition, index) => (
                <div
                    className='automation-condition-group__row'
                    key={`${group}-${index}`}>
                    <div className='automation-condition-group__fields'>
                        <SelectUI
                            name={`field-${group}-${index}`}
                            placeholder='Field'
                            options={CONDITION_FIELD_OPTIONS}
                            value={findOption(
                                CONDITION_FIELD_OPTIONS,
                                condition.field
                            )}
                            onChange={({ value }) =>
                                onUpdate(group, index, "field", value)
                            }
                        />
                        <SelectUI
                            name={`operator-${group}-${index}`}
                            placeholder='Operator'
                            options={OPERATOR_OPTIONS}
                            value={findOption(
                                OPERATOR_OPTIONS,
                                condition.operator
                            )}
                            onChange={({ value }) =>
                                onUpdate(group, index, "operator", value)
                            }
                        />
                        {renderValueInput(condition, index)}
                    </div>
                    <div className='automation-condition-group__remove'>
                        <ReactSVG
                            src={asset.icons.trashIcon}
                            onClick={() => onRemove(group, index)}
                        />
                    </div>
                </div>
            ))}

            <div className='automation-condition-group__add'>
                <AddButton
                    btnText='Add condition'
                    onClick={() => onAdd(group)}
                />
            </div>
        </section>
    );
};

export default AutomationConditionGroup;
